import swal from "sweetalert";

export function doubleConfirmation({
  // eslint-disable-next-line max-len
  title = 'Quick Update', text = '', showCancelButton = false, confirmButtonColor = '#e53935', confirmButtonText = 'Accept',
}) {
  const response = swal({
    title,
    text,
    icon: 'warning',
    showCancelButton,
    confirmButtonColor,
    confirmButtonText,
  });
  return response;
}

export function errorMessage(message) {
  swal({
    title: `${message}`,
    text: "Please, try again.",
    icon: "error",
    dangerMode: true,
  });
}

export function errorMessageTender(message) {
  swal({
    title: "Please, try again.",
    text: `${message}`,
    icon: "error",
    dangerMode: true,
  });
}

export function creditLimitErrorMessage(message) {
  const content = document.createElement("div");
  content.className = "credit-limit-message";
  content.innerHTML = `<hr><span style="color: #043663;">${message}</span>`;

  swal({
    title: "Credit Limit Reached",
    content,
    buttons: {
      confirm: {
        text: "Accepted",
        value: true,
        visible: true,
        className: "credit-accept-button"
      }
    },
    className: "credit-limit-swal",
    closeOnClickOutside: false,
    closeOnEsc: false,
    dangerMode: false,
  });
  setTimeout(() => {
    const swalTitle = document.querySelector(".swal-title");
    if (swalTitle && !document.querySelector(".credit-limit-close")) {
      const closeBtn = document.createElement("button");
      closeBtn.className = "credit-limit-close";
      closeBtn.type = "button";
      closeBtn.setAttribute("aria-label", "Close");
      closeBtn.innerHTML = '<i class="ion ion-close-circle-outline"></i>';
      swalTitle.parentElement.insertBefore(closeBtn, swalTitle.nextSibling);
      closeBtn.addEventListener("click", () => {
        swal.close();
      });
    }
  }, 100);
}

export function errorNotFoundMessage(event) {
  swal({
    title: "There is something wrong",
    text: `${event} not found!`,
    icon: "error",
    dangerMode: true,
  });
}

export function tokenExpired() {
  swal({
    title: "The token has expired",
    text: "Please, login again",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  });
  this.$router.push({
    name: "Login",
  });
}

export function confirmChange() {
  swal({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      swal("Deleted!", {
        icon: "success",
      });
    }
  });
}

export function generalMessage(event) {
  swal({
    title: 'Good Job!',
    text: `${event}`,
    icon: "success",
  });
}

export function warningMessage(message, subText = 'Please try again') {
  swal({
    title: `${message}`,
    text: `${subText}`,
    icon: "warning",
    dangerMode: false,
  });
}
